import Aos from "aos";
import { useEffect } from "react";

const goals = [
  { label: "Car", color: "green" },
  { label: "Rent", color: "white" },
  { label: "Travel", color: "pink" },
  { label: "Business", color: "lavender" },
  { label: "Emergency", color: "mauve" },
  { label: "New home", color: "white" },
  { label: "Education", color: "white" },
];

const BankvoleGoalsSection = () => {
  useEffect(() => {
        Aos.init({
            duration: 1000,
        });
    }, []);
  return (
    <section className="bv-goals">
      <div className="bv-goals-inner">
        <div className="bv-goals-left" data-aos="fade-down" data-aos-duration="1000">
          <h2 className="bv-goals-title">
            Built for real-life <br /> goals
          </h2>
          <p className="bv-goals-text">
            From rent and education to travel, business and emergencies, plan
            confidently and stay on track.
          </p>
        </div>
        <div className="bv-goals-right" data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="300">
          <div className="bv-goals-pills">
            {goals.map((goal) => (
              <span key={goal.label} className={`bv-pill bv-pill--${goal.color}`}>
                {goal.label}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BankvoleGoalsSection;